module.exports = __webpack_public_path__ + "images/emoji/v.6a22542850a320744d79.png";